import { isValidPkMobile } from './pk-mobile';

/**
 * POS-I179: the New Delivery Order dialog prefills the customer mobile from the picked sale.
 * Switching the sale must replace that prefilled number with the new customer's; only a number
 * the cashier typed (phoneEdited) is kept.
 */
export function phoneForSaleChange(
  current: { phone: string; phoneEdited: boolean },
  salePhone?: string | null,
): { phone: string; phoneEdited: boolean } {
  if (current.phoneEdited && current.phone.trim()) return { phone: current.phone, phoneEdited: true };
  return { phone: isValidPkMobile(salePhone) ? (salePhone ?? '') : '', phoneEdited: false };
}

/**
 * The zone fee depends on the sale total (free-above amount). When the sale changes, re-quote the
 * fee of an already chosen zone unless the cashier entered the fee by hand (a reason is set).
 */
export function feeForSaleChange(
  current: { zoneId: string; deliveryFee: number; feeReason: string },
  quotedFee: number | null,
): number {
  if (!current.zoneId || current.feeReason.trim() || quotedFee === null) return current.deliveryFee;
  return quotedFee;
}
